import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#13CB75" />
    <g clipPath="url(#clip0_3662_31114)">
      <path
        d="M8.20511 5.15943H8.14136V3.3763C8.14136 2.70943 7.83324 2.4313 7.45386 2.81068L3.92511 6.33568C3.74326 6.51869 3.64124 6.76625 3.64136 7.02425C3.64147 7.28225 3.74372 7.52971 3.92574 7.71256L7.42761 11.2013C7.80699 11.5788 8.14136 11.1951 8.14136 10.6344V8.75318H8.67199C10.2032 8.75318 11.3707 9.57443 12.0876 11.1601C12.2276 11.4476 12.3751 11.3844 12.3751 11.1601C12.3439 8.33506 10.4176 5.15943 8.20511 5.15943Z"
        fill="#343538"
      />
    </g>
    <defs>
      <clipPath id="clip0_3662_31114">
        <rect width="10" height="10" fill="white" transform="translate(3 2)" />
      </clipPath>
    </defs>
  </svg>
);

export default SVGComponent;
